import React from 'react';
import {darken, makeStyles} from '@material-ui/core/styles';
import {Box, Card, CardActions, CircularProgress, Collapse, TableCell} from '@material-ui/core';
import VectorStepper from "./VectorStepper";
import {Grid} from '@material-ui/core';
import SimpleNumberCard from "../../metrics/SimpleNumberCard";
import IconButton from "@material-ui/core/IconButton";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import clsx from "clsx";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import VectorAttacksTable from "../VectorAttacksTable"
import GolfCourseSharpIcon from '@material-ui/icons/GolfCourseSharp';
import Tooltip from "@material-ui/core/Tooltip";
import LanguageSharpIcon from '@material-ui/icons/LanguageSharp';
import DesktopWindowsSharpIcon from '@material-ui/icons/DesktopWindowsSharp';
import MeetingRoomSharpIcon from '@material-ui/icons/MeetingRoomSharp';
import PropTypes from "prop-types";
import {
    bbFormattedDateString,
    bbGetArrayOfVulnsFromObjectOrString,
    bbIsVectorPotentiallyBreaching,
    bbScopeIcon,
    bbShortenString, bbTranslateVectorStatusToLikelihood
} from "../../../../util/bbHelpers";
import {Badge} from "reactstrap";
import BBIconComputerBugCVE from "../../../../assets/bbCustomIcons/BBIconComputerBugCVE";
import KeyboardTabSharpIcon from "@material-ui/icons/KeyboardTabSharp";
import BBIconCalendarPlus from "../../../../assets/bbCustomIcons/BBIconCalendarPlus";
import Riskmeter from "../../BBRiskMeter/Riskmeter";
import BBExternalLink from "../../accents/BBExternalLink";

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        textAlign: "center",
    },
    rootInactiveVector: {
        width: '100%',
        textAlign: "center",
        opacity: 0.75
    },
    button: {
        marginRight: theme.spacing(2),
    },
    completed: {
        display: 'inline-block',
    },
    instructions: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    target: {
        backgroundColor: darken("#ffffff", .025),
    },
    targetInactive: {
        backgroundColor: darken("#ffffff", .25),
    },
    capability: {
        backgroundColor: darken("#ffffff", .025),
    },
    expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    footer: {

        borderTop: "solid 2px gray",
        borderBottom: "solid 9px gray",
        padding: 0,

    },
    expandIcon: {
        fontSize: 16,
    },
    footNote: {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        fontSize: "smaller",
        color: 'gray'
    },
    subtitle: {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        fontSize: "smaller",
        color: 'gray'
    },
    headerRow: {
        marginTop: theme.spacing(1),
        fontWeight: theme.typography.fontWeightBold,
    },
    headerRowSecondary: {
        marginTop: theme.spacing(3),
        fontWeight: theme.typography.fontWeightBold,
    },
    centerFootNote: {
        marginLeft: 'auto',
        marginRight: 'auto',
        fontSize: "smaller",
        color: 'gray'
},
    wholeBox: {
        margin: 0,
        // border: "5px solid red"
    },
    collapse: {
        backgroundColor: 'gray',
    },
    progressBar : {
        colorPrimary : {
            color: "warning"
        }
    },
    progressBarInactive : {
        colorPrimary : {
            color: "light"
        }

    }
}));

function VectorCard(props) {
    const classes = useStyles();
    const [expanded, setExpanded] = React.useState(false);

    const {vector, target, customerId} = props;
    const isVectorPotentiallyBreaching = (bbIsVectorPotentiallyBreaching(vector));
    const isTargetEmpty = target === null;
    const isTargetActive = (target && target.hasOwnProperty("IsActive")) ? target.IsActive !== false : null;

    // console.log("Building a vectorcard with vector: ", vector, "target ", target, "and customerId", customerId)

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    const getOriginIpAddress = () => {
        if (vector && vector.Attacks && !Object.keys(vector.Attacks).length) {
            return "Pending"
        }else {

            //get all Ips from attack objects
            const attackIPs = []
            for (const attack in vector.Attacks) {
                // attackIPs.push(vector.Attacks[attack].Details["Attack Origin Ip Address"]);
                const isBasicItem = vector.Attacks[attack].hasOwnProperty("Details")
                const ipToPush =  isBasicItem //vector
                    ? vector.Attacks[attack].Details["Attack Origin Ip Address"]
                    : vector.Attacks[attack]["Perimeter Attack Detail"]["Attack Origination Ip"]
                attackIPs.push(ipToPush);
            }

            //sort
            const uniqueIps = [...new Set(attackIPs)];

            let displayString = uniqueIps.hasOwnProperty(0) ? uniqueIps[0] : "Pending";
            if (uniqueIps.hasOwnProperty(1)) {
                displayString.concat(", " + uniqueIps[1]);
            }

            return displayString;
        }
    }

    // const getActivityOngoingDays = () => {
    //     if (vector && vector["Attack Totals"] && vector["Attack Totals"].attacks < 1) {
    //         return "Pending";
    //     } else {
    //         //get all dates from attack objects
    //         const attackDates = []
    //         for (const attack in vector.Attacks) {
    //             attackDates.push(bbDangerousStringToDate(vector.Attacks[attack]["Attack DateTime"]));
    //         }
    //
    //         //sort
    //         attackDates.sort((a, b) => a - b);
    //
    //         const earliestDate = attackDates[0];
    //         // console.log("Earliest Attack date is", earliestDate)
    //         const now = Date.now();
    //         const daysSinceEarliestDate = Math.floor((now - earliestDate)/1000/60/60/24) + 1;
    //
    //         return isNaN(daysSinceEarliestDate) ? "..." : daysSinceEarliestDate;
    //     }
    // }

    const getCreatedDateDisplay = () => {
        // date the vector was created
        const createdDate =  (vector && vector["Identified DateTime"]) ? vector["Identified DateTime"] : null;
        if (createdDate) {
            return <Tooltip title={`This vector was identified on ${bbFormattedDateString(createdDate, "long")}.`}>
                <span>
                    {bbFormattedDateString(createdDate, "microYear")}
                </span>
            </Tooltip>
        } else {
            return "..."
        }
    }

    const getNumberOfAttackEvents = () => {
        // return (vector && vector.Attacks) ? Object.keys(vector.Attacks).length : "...";
        const numAttacks = (vector && vector["Attack Totals"]) ? vector["Attack Totals"].attacks : null;
        if (numAttacks !== null && numAttacks >= 0) {
            return <Tooltip title={`${numAttacks} attacks have been launched as a part of this vector. For more details, expand the Attack Event table below.`}>
                <span>
                    {numAttacks}
                </span>
            </Tooltip>
        } else {
            return "..."
        }
    }

    const getLastAttackDate = () => {
        // return (vector && vector.Attacks) ? Object.keys(vector.Attacks).length : "...";
        return (vector && vector["Attack Totals"]) ? vector["Attack Totals"].lastAttack ? bbFormattedDateString(vector["Attack Totals"].lastAttack, "short") : "N/A" :  "...";
    }

    const getPercentOfAttacksDefeated = () => {
        // return (vector && vector.Attacks) ? Object.keys(vector.Attacks).length : "...";
        const totalAttackEvents = (vector && vector["Attack Totals"]) ? vector["Attack Totals"].attacks : null;
        const numAttacksDefeated = (vector && vector["Attack Totals"]) ? vector["Attack Totals"].attacks_defeated : null;
        if (totalAttackEvents && totalAttackEvents !== 0 && numAttacksDefeated && numAttacksDefeated >= 0) {
            const percentDefeated = Math.trunc(numAttacksDefeated / totalAttackEvents * 100);
            if (percentDefeated >= 0 && percentDefeated <= 100) {
                //number appears to be a good percentage
                const textColor = percentDefeated === 100 ? "bb-risk-lowest" : "bb-risk-highest";
                return <Tooltip title={`${numAttacksDefeated} out of ${totalAttackEvents} attack events have been unsuccessful.`}><span className={`text-${textColor}`}>{`${percentDefeated}%`}</span></Tooltip>
            } else {
                //number is not as expected.
                return <Tooltip title={`Further analysis is required regarding ${numAttacksDefeated} attack events.`}><span>...</span></Tooltip>
            }

        } else {
            return <Tooltip title={`No attacks within this vector have occurred yet.`}><small>N/A</small></Tooltip>
        }
    }

    const fqdnShort = target.Fqdn
        ? Array.isArray(target.Fqdn)
            ? target.Fqdn.length > 0
                ? <Tooltip title={`${target.Fqdn.join(", ")}`}><span>{bbShortenString(target.Fqdn.join(", "), 50, true)}</span></Tooltip>
                : "None detected"
            : <Tooltip title={`${target.Fqdn}`}><span>{bbShortenString(target.Fqdn, 50, true)}</span></Tooltip>
        : "None detected"


    return (
        <Card className={isVectorPotentiallyBreaching ? classes.root : classes.rootInactiveVector} elevation={10}>
            <Grid container
                  spacing={0}
                  alignItems="stretch"
                  justifyContent="center"
                  direction="row"
                  className={classes.wholeBox}
            >
                <Grid item xs={3} className={classes.capability} >
                    <Box className={classes.headerRowSecondary}>
                        <Tooltip title={"The BreachBits capability that has been matched against this target."}><h3>Attack Capability</h3></Tooltip>
                        <br/>
                        <Table className={classes.table} size="small">
                            <TableBody>
                                <TableRow>
                                    <TableCell>
                                        <Tooltip title={"Creation Date"}><span><BBIconCalendarPlus/></span></Tooltip>
                                    </TableCell>
                                    <TableCell>
                                       {getCreatedDateDisplay()}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>
                                        <Tooltip title={"Tactic"}><span><KeyboardTabSharpIcon/></span></Tooltip>
                                    </TableCell>
                                    <TableCell>
                                        <small>
                                            <BBExternalLink
                                                href={`${vector.Capability.Tactic["Att&ck Url"]}`}
                                                tipText={`Tactic: ${vector.Capability.Tactic["Tactic Name"]}. Click to learn more in a new browser tab.`}
                                            >
                                                {`${bbShortenString(vector.Capability.Tactic["Tactic Name"], 50, true)}`}
                                            </BBExternalLink>
                                        </small>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>
                                        <Tooltip title={"Vulnerable Service"}><span><MeetingRoomSharpIcon/></span></Tooltip>
                                    </TableCell>
                                    <TableCell>
                                        <code>{`${bbShortenString(vector.Capability.Service, 50, true)}`}</code>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>
                                        <Tooltip title={"Purpose | Goal of this Vector"}><span><GolfCourseSharpIcon/></span></Tooltip>
                                    </TableCell>
                                    <TableCell>
                                        {`${bbShortenString(vector.Capability.Tactic["Att&ck Category"], 25, true)}`}
                                    </TableCell>
                                </TableRow>

                            </TableBody>
                        </Table>
                    </Box>
                    <br/>
                    <SimpleNumberCard title={getOriginIpAddress()} number={""} topTitle={""} subtitle={"Origin IP Addresses"}/>
                </Grid>
                <Grid item xs={6}>
                    <Grid container
                        spacing={0}
                          justifyContent="center"
                        direction="row"
                    >
                        <Grid item xs>
                            <Box className={classes.headerRow}>
                                {/*<h6>Attack Vector:</h6>*/}

                                <h1>{`${bbShortenString(vector.Capability.Name, 50, true)}`}</h1>

                                <Typography className={classes.subtitle}>{`${bbShortenString(vector.Capability.Description, 200, true)}`}</Typography>
                                {/*{bbIsVectorRisk(vector, 3) && <Tooltip title={"Viable Vectors are especially likely to cause a breach at in the near or medium-term. Attackers will likely try to cause a breach using this Vector."}><div className={"bg-bb-risk-high pulse pulse-slow"} style={{borderRadius:"6px", zIndex:"2", fontSize: "larger"}}>  <Badge color="bb-risk-high">Viable Vector</Badge></div></Tooltip>}*/}

                            </Box>
                        </Grid>
                    </Grid>
                    <Grid container
                          spacing={0}
                          justifyContent="center"
                          direction="row"
                    >
                        <Grid item xs>
                            {/*<Box ><SimpleNumberCard number={bbGetLikelihoodBadgeFrom(vector)} title={"Breach Likelihood"}/></Box>*/}
                            <Box >
                                <SimpleNumberCard number = {
                                    <Riskmeter
                                        currentValueText={' '}
                                        // width = {125}
                                         height = {80}
                                        value={(bbTranslateVectorStatusToLikelihood(vector) * 20) + 10}
                                        valueTextFontSize={'16px'}
                                    />
                                } title={"Breach Likelihood"}
                                style={{marginTop:-30}}/>

                                </Box>
                        </Grid>
                        <Grid item xs>
                            <Box style={{ cursor: 'pointer'}} onClick={handleExpandClick}>
                                    <SimpleNumberCard number={getNumberOfAttackEvents()} title={"Attacks"} />
                            </Box>
                        </Grid>
                        <Grid item xs>
                            <Box style={{ cursor: 'pointer'}} onClick={handleExpandClick}>
                                <SimpleNumberCard number={getPercentOfAttacksDefeated()} title={"Defeated"} />
                            </Box>
                        </Grid>
                    </Grid>
                    <Grid container
                          spacing={0}
                          justifyContent="center"
                          direction="row"
                          >
                        <Grid item xs>
                            <Box style={{width: "100%"}}><VectorStepper currentStatus={vector.Status.Id} description={`${bbShortenString(vector.Status.Description, 144, true)}`}/></Box>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={3} className={classes.target}>
                    <Box className={classes.headerRowSecondary}>
                        <Tooltip title={"The target undergoing attack in this vector."}>
                            <h3>Target Host</h3>
                        </Tooltip>
                        {isTargetActive && bbScopeIcon(target.OutOfScope)} &nbsp;

                        {!isTargetActive && <Tooltip title={"CIRT cannot detect this target. It has likely moved or been removed. CIRT may attempt to re-detect in the future."}><span><Badge color="info">INACTIVE</Badge></span></Tooltip> }
                    <Table className={classes.table} size="small">
                        <TableBody>
                            <TableRow>
                                <TableCell>
                                    <Tooltip title={"Domain (FQDN) Detected"}><span><LanguageSharpIcon/></span></Tooltip>
                                </TableCell>
                                <TableCell>
                                    {isTargetEmpty && <small>Loading...</small>}
                                    {!isTargetEmpty &&  fqdnShort}

                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    <Tooltip title={"Operating System Detected"}><DesktopWindowsSharpIcon/></Tooltip>
                                </TableCell>
                                <TableCell>
                                    <Tooltip title={`${bbShortenString(target.OsDetails ? target.OsDetails.Description ? target.OsDetails.Description : "Pending" : "Pending", 50, true)}`}>
                                        <span>
                                        {(target.OsDetails && target.OsDetails.Logo) && (
                                            <img style={{height: 18}} src={target.OsDetails.Logo} alt={`${bbShortenString(target.OsDetails.Name, 25, true)}`} />
                                        )}
                                        {(!target.OsDetails && !target.OsDetails.Logo) && (
                                            <>Pending</>
                                        )}
                                        </span>
                                    </Tooltip>

                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    <Tooltip title={"Common Vulnerabilities and Exposures (CVEs) Detected"}><span><BBIconComputerBugCVE/></span></Tooltip>
                                </TableCell>
                                <TableCell>
                                    {isTargetEmpty && <>Loading...</>}
                                    {!isTargetEmpty && (
                                        `${bbShortenString(vector["Target Details"] ? bbGetArrayOfVulnsFromObjectOrString(vector["Target Details"].Vulnerabilities).length : "Pending", 16, true)}`
                                    )}

                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                    </Box>
                    <br/>
                    {isTargetEmpty && <CircularProgress />}
                    {!isTargetEmpty &&
                        <SimpleNumberCard
                            title={
                                <BBExternalLink href={vector.Uri.includes("://") ? vector.Uri : `http://${vector.Uri}`} tipText={vector.Uri}>
                                    {bbShortenString(vector.Uri, 75, true)}
                                </BBExternalLink>
                            }
                            number={""}
                            topTitle={""}
                            subtitle={"Target URI"}
                        />
                    }

                </Grid>

                {/*<Grid container*/}
                {/*      spacing={0}*/}
                {/*      alignItems="stretch"*/}
                {/*      justify="center"*/}
                {/*      direction="row"*/}
                {/*      className={classes.wholeBox}*/}
                {/*>*/}
                {/*    <Grid item xs={12} className={classes.capability} >*/}
                {/*        {isVectorActive && <LinearProgress color="secondary" />}*/}
                {/*        {!isVectorActive && (*/}
                {/*            <>*/}
                {/*                <LinearProgress*/}
                {/*                    variant="determinate"*/}
                {/*                    value = "100"*/}
                {/*                    classes={{progressBar: classes.colorPrimary}}*/}
                {/*                />*/}
                {/*            </>*/}
                {/*        )}*/}
                {/*    </Grid>*/}
                {/*</Grid>*/}

            </Grid>
            <Tooltip title={"Expand to see a table of Attack Events related to this vector."}>
                <CardActions disableSpacing  className={classes.footer} onClick={handleExpandClick} type={"button"}>
                    {/*<IconButton aria-label="add to favorites">*/}
                    {/*    <FavoriteIcon />*/}
                    {/*</IconButton>*/}
                    {/*<IconButton aria-label="share">*/}
                    {/*    <ShareIcon />*/}
                    {/*</IconButton>*/}

                    <Typography className={classes.footNote} >Last Attack: {getLastAttackDate()}</Typography>
                    <Typography className={classes.centerFootNote} >{`ID: ${bbShortenString(vector.Id, 9)}`}</Typography>
                    <Typography className={classes.footNote} ><strong>Expand for Attack Event details.</strong></Typography>
                    <IconButton
                        className={clsx(classes.expand, {
                            [classes.expandOpen]: expanded,
                        })}

                        aria-expanded={expanded}
                        aria-label="show more"
                    >
                        <ExpandMoreIcon className={classes.expandIcon} />
                    </IconButton>
                </CardActions>
            </Tooltip>
            <Collapse in={expanded} timeout="auto" unmountOnExit className={classes.collapse}>
                <CardContent>
                    <VectorAttacksTable vectorId={vector.Id} customerId={customerId}/>
                </CardContent>
            </Collapse>
        </Card>
    );
}

VectorCard.propTypes = {
    vector: PropTypes.object.isRequired,
    target: PropTypes.object.isRequired,
};

export default VectorCard;